import { Box, Badge, Grid, GridItem } from '@chakra-ui/react'


function IconListItem ({iconText, description, badgeVariant}) {

    const bgc = badgeVariant === 'outline' ? 'white' : 'black'//'#99000'
    const fc = badgeVariant === 'outline' ? 'black' : 'white'

    return (

        <Box w="100%" border='0px' mb={0.5}>
            <Grid
            templateColumns='1fr 1fr 1fr 1fr 1fr 1fr'
            gap={2}
            >
                <GridItem colSpan={1}  my={3}>
                    <Badge 
                        variant={badgeVariant} 
                        borderRadius='none' 
                        px='1'
                        py={2} 
                        fontSize='0.9em' 
                        w={32}
                        backgroundColor={bgc}
                        color={fc}
                        textAlign='center'
                        >
                        {iconText}
                    </Badge>
                </GridItem>
                <GridItem colSpan={5} my={3} alignContent={'center'}>
                <Box
                    color='gray.900'
                    fontWeight='normal'
                    letterSpacing='normal'
                    lineHeight='1.1'
                    fontSize='md'
                    ml='1'
                    mb='1'
                    border='0px'
                    >
                        {description} 
                </Box>
                </GridItem>
            </Grid>
        </Box>
    )
}

export default IconListItem
